// this file is generated by update_shopify_store_data.py at 2026-06-22 20:27:34.965637
var courses = [];